import { Route, Redirect, Switch, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Register from '@pages/register'
import SameNameCompany from '@pages/same-name-company'
import Loading from "@pages/loading";
import BindPhone from "@pages/bind-phone";
import JoinCompany from "@pages/join-company";
import CompanyProfileFission from "@pages/company-profile-fission";
import DownloadApp from "@pages/download-app";
import CameraPlayer from "@pages/camera-player";
import MyDispatch from '@pages/my-dispatch'
import MyDispatchOld from '@pages/my-dispatch-old'
import Signature from "@pages/signature";
import useQuery from "hooks/useQuery.hook";



import { useEffect } from "react";
import { loginByPersonId } from "@api/user.api";
import { ActionType } from "@store/action-type.constant.t";
import { setLocalUser } from "@service/user.service";
import ComponentTry from "@pages/component-try";


const MainRoute = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const personId = useSelector<any>(state => state.user.personId);
  const previewPersonId = useQuery().previewPersonId as string;

  // login by preview personId
  useEffect(() => {
    const loginByPreviewPersonId = async (personId: string) => {
      const res = await loginByPersonId(personId);
      if (res.personId) {
        // set redux
        dispatch({ type: ActionType.SET_USER, payload: res })
        // set localstorage
        setLocalUser(res);
        window.accessToken = res.accessToken;
        if (!res.mobile) {
          history.push('/bind');
        }
      }
    }
    if (!!previewPersonId && previewPersonId !== personId) {
      loginByPreviewPersonId(previewPersonId);
    }
  })

  return (<Switch>
    {/* 无需登陆的页面 */}
    <Route path="/downloadApp" component={DownloadApp} />
    <Route path="/joinCompany" component={JoinCompany} />
    <Route path="/player" component={CameraPlayer} />
    <Route path="/my-dispatch" component={MyDispatch} />
    <Route path="/my-dispatch-old" component={MyDispatchOld} />
    <Route path="/signature" component={Signature} />
    {/* to-do 需要删除或隐藏 */}
    <Route path="/component-try" component={ComponentTry} />
    
    {/* 需要登录的页面 */}
    {!(personId || previewPersonId)&&<Route path="/" component={Loading} />}
    <Redirect exact from="/" to="/register" />
    <Route path="/bind" component={BindPhone} />
    <Route path="/register" component={Register} />
    <Route path="/sameNameCompany" component={SameNameCompany} />
    <Route path="/companyProfileFission" component={CompanyProfileFission} />
    
  </Switch>)

};
export default MainRoute
